import React from "react";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { QueryBuilderBox } from "../../common/QueryBuilderBox";
import { colorsAndLabelsByOp } from "../../../../../system/query/QueryUtility";
import { QuerySegmentProps } from "../../common/QuerySegmentContainer";
import { QueryLeafNode } from "system/query/QueryLeafNode";
import { QueryBuilderFieldLabel } from "../../common/QueryBuilderFieldLabel";
import { QueryBuilderInnerLabel } from "../../common/QueryBuilderInnerLabel";
import MultiValueViewer from "./MultiValueViewer";
import RangeValueViewer from "./RangeValueViewer";

export interface QueryLeafNodeBuilderProps extends QuerySegmentProps {
  queryLeafNode: QueryLeafNode;
  isViewerMode?: boolean;
}

export default function QueryLeafNodeBuilder(props: QueryLeafNodeBuilderProps): JSX.Element {
  const theme = useTheme();
  const {i18n} = useTranslation();

  const { backgroundColor, borderColor, borderColorTop, label } = colorsAndLabelsByOp(i18n, theme.colors.namedColors, props.queryLeafNode.op);

  let firstField = props.queryInfo?.fields?.find(field => {
    return field.id === props.queryLeafNode.field || props.queryLeafNode.fields?.includes(field.id);
  });

  if (!firstField && props.inSpan) {
    firstField = props.queryInfo?.fields?.find(field => {
      // find the first text field
      return field.type === "text";
    });
  }

  return (
    <Box>
    <QueryBuilderBox
        path={props.path}
        isAddingActive={props.isAddingActive}
        draggable={props.path?.length > 0}
        backgroundColor={backgroundColor}
        borderColor={borderColor}
        borderColorTop={borderColorTop}
        onClick={()=>{
          if (props.editSegment) {
            props.editSegment(props.queryLeafNode, props.parent, props.inSpan, props.spanSide);
          }
        }} >
      {!props.inSpan &&
        <QueryBuilderFieldLabel
          queryInfo={props.queryInfo}
          isViewerMode={props.isViewerMode}
          fieldId={props.queryLeafNode.field}
          multiFieldIds={props.queryLeafNode.fields}
          borderColor={borderColor}
          borderColorTop={borderColorTop}
          inline={true} />
      }
      <QueryBuilderInnerLabel>{label}</QueryBuilderInnerLabel>
      {(firstField || props.inSpan) &&
      <>
        <MultiValueViewer
          value={props.queryLeafNode?.value}
          values={props.queryLeafNode?.values}
          label={props.queryLeafNode?.label}
          labels={props.queryLeafNode?.labels}
          queryInfo={props.queryInfo}
          field={firstField}
          isViewerMode={props.isViewerMode}
          borderColor={borderColor}
          borderColorTop={borderColorTop}
          />
        <RangeValueViewer
          lowerValue={props.queryLeafNode?.lower}
          upperValue={props.queryLeafNode?.upper}
          queryInfo={props.queryInfo}
          field={firstField}
          isViewerMode={props.isViewerMode}
          borderColor={borderColor}
          borderColorTop={borderColorTop}
          />
      </>
      }
    </QueryBuilderBox>
    </Box>
  );
}